import React from 'react';
import { withStyles } from 'tss-react/mui';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles((props) => {
  const { children, classes, onClose, align, ...other } = props;
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      <Box>
        <Typography variant="h6" align={align}>
          {children}
        </Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        ) : null}
      </Box>
    </MuiDialogTitle>
  );
}, styles);

const DialogContent = withStyles(MuiDialogContent, (theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}));

const DialogActions = withStyles(MuiDialogActions, (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}));

function AxlDialog({ isOpen, childrenTitle, childrenAction, children, handleClose, maxWidth = 'md', alignTitle = 'inherit', DialogContentProps, styleDialog = {} }) {
  return (
    <Dialog onClose={handleClose} open={isOpen} fullWidth maxWidth={maxWidth} sx={{ ...styleDialog }}>
      <DialogTitle onClose={handleClose} align={alignTitle}>
        {childrenTitle}
      </DialogTitle>
      <DialogContent dividers {...DialogContentProps}>
        {children}
      </DialogContent>
      {childrenAction && <DialogActions>{childrenAction}</DialogActions>}
    </Dialog>
  );
}

export default AxlDialog;
